
import { CalculatedValueAddToDate, CalculationType, Field, FieldExtensionsIds } from "@/types"
import { Component, Emit, Prop, Vue } from "vue-property-decorator"
import vSelect from "vue-select"
import Numeric from "./Numeric.vue"
import HelpIcon from "../New/Page/PageComponents/HelpIcon.vue"
import { AddToDateInputArgs } from "@/types/fields/addToDate"

@Component({
	components: {
		"v-select": vSelect,
		"numeric": Numeric,
		"help-icon": HelpIcon
	}
})
export default class AddToDate extends Vue {
	@Prop()
	value!: CalculatedValueAddToDate | null

	@Prop({ type: Array, default: [] })
	dateFields!: Field[]

	@Prop({ type: Array, default: [] })
	numericFields!: Field[]

	@Prop({ type: Boolean, default: false })
	closeOnSelect!: boolean

	@Prop({ type: Boolean, default: false })
	disabled!: boolean

	@Emit("input")
	private onDateFieldChanged (fieldId: string) : AddToDateInputArgs {
		const updatedValue = {
			fields: [fieldId, ...(this.value?.add ? this.value?.add as string[] : [])],
			calculationType: CalculationType.AddToDate,
			dateField: fieldId,
			add: this.value?.add,
			showTime: true,
			static: this.value?.static
		} as CalculatedValueAddToDate

		return new AddToDateInputArgs(updatedValue, FieldExtensionsIds.DateField)
	}

	@Emit("input")
	private onAddChanged (fieldIds: string[]) : AddToDateInputArgs {
		const updatedValue = {
			fields: [this.value?.dateField, ...fieldIds],
			calculationType: CalculationType.AddToDate,
			dateField: this.value?.dateField,
			add: fieldIds,
			showTime: true,
			static: this.value?.static
		} as CalculatedValueAddToDate

		return new AddToDateInputArgs(updatedValue, FieldExtensionsIds.Add)
	}

	@Emit("input")
	private onStaticChanged (value: string) : AddToDateInputArgs {
		const updatedValue = {
			fields: this.value?.fields,
			calculationType: CalculationType.AddToDate,
			dateField: this.value?.dateField,
			add: this.value?.add,
			showTime: true,
			static: value
		} as CalculatedValueAddToDate

		return new AddToDateInputArgs(updatedValue, FieldExtensionsIds.Static)
	}
}
